import contained from "./contained";
import text from "./text";
import outlined from "./outlined";
import soft from "./soft";
import { ComponentsOverrides, Theme } from "@mui/material";
import { InternalThemeConfig } from "../../config";

const getButton = (
  config: InternalThemeConfig
): ComponentsOverrides<Theme>["MuiButton"] => {
  const containedOverrides = contained(config);
  const outlinedOverrides = outlined(config);
  const textOverrides = text(config);
  const softOverrides = soft(config);
  const { palette, spacing } = config;

  return {
    root: {
      fontFamily: "RoobertCEZ",
      minWidth: undefined,
      fontWeight: 400,
      fontSize: "1.6rem",
      padding: "1.2rem 3.2rem",
      minHeight: "5.6rem",
      borderRadius: "0.8rem",
      textTransform: "none",
      letterSpacing: "0.2px",
      textAlign: "center",
      boxShadow: undefined,
      color: undefined,
      "&:hover": {
        textDecoration: undefined,
        backgroundColor: undefined,
      },
      "&:disabled": {
        boxShadow: undefined,
        color: palette.grey30,
        backgroundColor: palette.grey40,
        background: palette.grey40,
      },
    },
    sizeSmall: {
      padding: `${spacing(1.5)} ${spacing(3)}`,
      fontSize: spacing(1.75),
    },
    ...containedOverrides,
    ...outlinedOverrides,
    ...softOverrides,
    ...textOverrides,
    iconSizeSmall: {
      width: spacing(2),
      height: spacing(2),
    },
    iconSizeMedium: {
      width: spacing(2),
      height: spacing(2),
    },
    iconSizeLarge: {
      width: spacing(2),
      height: spacing(2),
    },
  };
};

export default getButton;
